// import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

/**
 * 
 * @param { { idUsuario: Number, tipoMensaje: String } } data 
 * @returns { { idMensaje: Number, mensaje: String, fechaMensaje: Number } }
 */
async function getRecentMessages (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    // TODO - Recuperar objetos de mensaje para mensajes recientes
    // const req = {
    //   url: '/api/mensajes/getrecentmessages',
    //   method: 'GET',
    //   headers: {
    //     'Content-type': 'application/json',
    //     'access-control-allow-origin': '*'
    //   },
    //   params
    // }
    // const res = await axiosInstance(req)
    // return res.data
    return { blnError: false, Respuesta: [] }
    // return { blnError: false, Respuesta: [{ idMensaje: 1, mensaje: 'Prueba de rechazo', fechaMensaje: Date.now() }] }
  }
}

export { getRecentMessages }
